import { TRACKERS } from "@/constants/Trackers";
import { Timeline } from "@/features/Patient/MedicalRecords/Timeline";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/timeline")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_TIMELINE);
  },
});

function RouteComponent() {
  return <Timeline />;
}
